import { useState } from 'react';
import PropTypes from 'prop-types';
import {Button as MuiButton, Drawer, IconButton } from '@mui/material';
import _ from 'lodash';
import { useRouter } from 'next/router';
import moment from 'moment';
import CloseIcon from '@mui/icons-material/Close';

import { Image, FadeInAnimation, Button } from '../shared';
import useResponsive from '../../../utils/responsive';
import BlogPageFilters from './blog-page-filters.component';
import BlogMobileFilters from './blog-mobile-filters.component';
import { eventService } from '../../services/homii-services';


const BlogPagePosts = (props) => {
    const { data, blogTags } = props;
    const [selectedTag, setSelectedTag] = useState(null);
    const [selectedTagText, setSelectedTagText] = useState('all');
    const [drawerOpen, setIsDrawerOpen] = useState(false);
    const blogData = data;
    const { isMobile } = useResponsive();
    const router = useRouter();
    const { query } = router;
    const filter = _.get(router, 'query.filter');

    const onBlogPostClick = (blogPostSlug) => {
        eventService.logCustomEvent('viewed-blog-post', {
            description: `User viewed ${blogPostSlug} and was directed from blog page`,
            slug: blogPostSlug,
        });
        router.push(`/blog/posts/${blogPostSlug}`);
    };

    const checkForTags = (tags) => {

        return _.map(tags, (tag, index) => {

            const type = _.toUpper(_.get(tag, 'name'));

            return (

                <span className='blog-page-posts-span' key={index}>

                    {type}

                </span>

            );

        });

    };

    const handleDrawerClose = () => {
        setIsDrawerOpen(false);
    };

    const onApplyFilterClick = () => {
        const newQuery = { ...query };

        if (selectedTag) {
            newQuery.filter = selectedTag;
            if (newQuery.page) {
                newQuery.page = 1;
            }
            router.push(
                {
                    pathname: '/blog',
                    query: newQuery,
                },
                undefined,
                { shallow: false },
            );
        }

        handleDrawerClose();
    };

    const onDrawerClose = () => {
        setIsDrawerOpen(false);
    };
    
    const renderDesktopFilters = () => {
        if (isMobile) {
            return null;
        }

        return (

            <div className='blog-page-posts-filter-section'>

                <BlogPageFilters tags={blogTags} />

            </div>

        );
    };

    const onTagChange = (value) => {        
        const tag = _.find(blogTags, tag => parseInt(_.get(tag, 'id')) === parseInt(value));
        let selectedText =  _.get(tag, 'name');
        if (selectedText && selectedText.startsWith('#')) {
            selectedText = selectedText.substring(1);
        }        
        setSelectedTagText(selectedText);
        setSelectedTag(value);
    };

    const onFilterClick = () => {
        setIsDrawerOpen(true);
    };

    const filterTags = (tags, filter) => {
        const tag = _.find(tags, tag => parseInt(_.get(tag, 'id')) === parseInt(filter));
        return tag ? _.get(tag, 'name') : filter;
    };    


    const renderPosts = () => {
        return _.map(blogData, (post, index) => {
            const blogPostSrc = _.get(post, 'acf.featured_image');
            const blogPostAlt = _.get(post, 'acf.featured_image_alt_text');
            const blogPostSlug = _.get(post, 'acf.url_slug');
            const blogPostPublished = _.get(post, 'acf.meta_data_publish_date');
            const blogPostTitle = _.get(post, 'acf.seo_title');
            const blogPostTags = _.get(post, 'acf.meta_data_tags');

            return (

                <div className='main-grid-item main-grid-xl-6 main-grid-lg-6 main-grid-md-6 main-grid-sm-12 main-grid-xs-12 blog-page-posts-grid' 
                    onClick={() => onBlogPostClick(blogPostSlug)}
                    key={index}
                >
                    <FadeInAnimation>

                        <Image
                            isMobile={isMobile}
                            src={blogPostSrc}
                            alt={blogPostAlt}
                            width="100%"
                            height={450}
                            className="card-image blog-page-posts-image"
                            animate
                            isOldImage
                        />

                        {checkForTags(blogPostTags)}

                        <span className='blog-page-posts-span'>
                            {_.toUpper(moment(blogPostPublished).format('DD MMMM YYYY'))}
                        </span>

                        <h4 className='blog-page-posts-title '> {blogPostTitle} </h4>

                    </FadeInAnimation>

                </div>
            );
        });
    };

    return (

        <div className='container-root container-root-maxWidthLg blog-page-posts-container'>

            {renderDesktopFilters()}

            <div className='blog-page-posts-post-section'>

                <div className='blog-page-posts-post-content'>

                    <h4 className='blog-page-posts-filter-header' id="top">

                        {filter === 'all' || _.isNil(filter)
                            ? 'All Articles'
                            : `${filterTags(blogTags, filter)}`}

                    </h4>

                    {isMobile && 
                        <button className='blog-page-posts-pill-button' onClick={onFilterClick}>
                            <span className="blog-page-posts-pill-button-label">Filter</span>
                            <span className="blog-page-posts-pill-button-root"></span>
                        </button>
                    }

                    <Drawer
                        slotProps={{ paper: { square: false } }}                        
                        anchor="bottom"
                        open={drawerOpen}
                        onClose={onDrawerClose}
                    >
                        <div className='blog-page-posts-header-container'>

                            <h5 className='blog-page-posts-title-text'>Topic</h5>

                            <div>

                                <span className='blog-page-posts-selected-text'>
                                    {selectedTagText === 'all' || !selectedTagText ? 'All Topics' : `#${_.capitalize(selectedTagText)}`}
                                </span>

                                <IconButton className='blog-page-posts-close-button'
                                    disableRipple
                                    aria-label="close"
                                    onClick={handleDrawerClose}
                                >
                                    <CloseIcon className='blog-page-posts-close-button-icon' />
                                </IconButton>

                            </div>

                        </div>

                        <BlogMobileFilters
                            onChange={(value) => onTagChange(value)}
                            tags={blogTags}
                        />

                        <div className='blog-page-posts-filter-button-container'>

                            <Button className='blog-page-posts-filter-button'
                                isMobile={isMobile}
                                id="filter-button-mobile"
                                onClick={onApplyFilterClick}
                            >
                                Apply Filters
                            </Button>

                        </div>

                    </Drawer>

                </div>

                <div className='main-grid-container main-grid-spacing-xs-4'>

                    {renderPosts()}

                </div>

            </div>

        </div>
    );
};

export default BlogPagePosts;

BlogPagePosts.propTypes = {
    data: PropTypes.array,
    blogTags: PropTypes.array,
};

